import type { Api } from "../../services/api";

// The evidence check of one assistant run's answer, as the API serves it.
export type AssistantEvidenceCheck =
  Api["get"]["/assistant/conversations/:conversationId/evidence-checks"]["output"]["body"]["checks"][number]["state"];

// On, the Evidence tab shows the whole check, its unverified claims and its warnings included.
export const UNVERIFIED_EVIDENCE_FLAG = "assistant-evidence-unverified";

// What the Evidence tab of a run shows: a running check, the whole check, or only the claims that a kept quote settles.
export type ShownEvidenceCheck = NonNullable<
  ReturnType<typeof shownEvidenceCheck>
>;

// A running check shows its tab with or without the flag. Without it, a settled check keeps the tab only when it settles a claim, and the tab shows no warning.
export function shownEvidenceCheck(
  check: AssistantEvidenceCheck,
  showUnverified: boolean
) {
  if (check.status === "pending") return { scope: "pending" as const };
  if (showUnverified) return { scope: "all" as const, check };
  if (check.status !== "ready") return null;
  const claims = check.claims.flatMap((claim) => {
    switch (claim.status) {
      case "supported":
      case "contested":
        return [
          {
            id: claim.id,
            text: claim.text,
            status: claim.status,
            edges: claim.edges,
          },
        ];
      case "not_found":
        return [];
      default:
        throw new Error(claim.status satisfies never);
    }
  });
  return claims.length === 0 ? null : { scope: "verified" as const, claims };
}
